export function isLeaveApplyReviewMode({
	isAdminStay,
	sessionAccountType,
	sessionIsRoomMage,
	sessionAccount,
	targetAccount,
	fromDeduct,
	hasExistingLeaveRecord
}) {
	if (isAdminStay) {
		if (fromDeduct && !hasExistingLeaveRecord) {
			return false;
		}
		return true;
	}

	if (sessionAccountType === "STU") {
		return sessionIsRoomMage === "Y" && targetAccount !== sessionAccount;
	}

	return false;
}